<template>
<base-modal v-bind:modalTitle="providerName + ' Setup'" v-on:save="save()" v-on:close="close()">
  <FormulateForm>
    <h2>Billing Condition</h2>
    <boolean-expression-widget
      :expression="billingCondition"
      @updateExpression="updateBillingCondition">
    </boolean-expression-widget>
    <h2>Capacity Limits</h2>
    <FormulateInput type="group">
      <table class="table table-borderless">
        <tbody>
          <tr>
            <th>Hourly</th>
            <td>
              <FormulateInput
                type="number"
                v-model="capacity.hourly"
                min="1"
              />
            </td>
            <td>
              <FormulateInput
                label="-"
                type="button"
                @click="capacity.hourly = null">
                <i class="fa fa-trash"></i>
              </FormulateInput>
            </td>
          </tr>
          <tr>
            <th>Daily</th>
            <td>
              <FormulateInput
                type="number"
                v-model="capacity.daily"
                min="1"
              />
            </td>
            <td>
              <FormulateInput
                label="-"
                type="button"
                @click="capacity.daily = null">
                <i class="fa fa-trash"></i>
              </FormulateInput>
            </td>
          </tr>
          <tr>
            <th>Weekly</th>
            <td>
              <FormulateInput
                type="number"
                v-model="capacity.weekly"
                min="1"
              />
            </td>
            <td>
              <FormulateInput
                label="-"
                type="button"
                @click="capacity.weekly = null">
                <i class="fa fa-trash"></i>
              </FormulateInput>
            </td>
          </tr>
          <tr>
            <th>Monthly</th>
            <td>
              <FormulateInput
                type="number"
                v-model="capacity.monthly"
                min="1"
              />
            </td>
            <td>
              <FormulateInput
                label="-"
                type="button"
                @click="capacity.monthly = null">
                <i class="fa fa-trash"></i>
              </FormulateInput>
            </td>
          </tr>
        </tbody>
      </table>
    </FormulateInput>
  </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build.
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';
 import BooleanExpressionWidget from 'components/elements/BooleanExpressionWidget';

 export default {
   components: {
     BaseModal,
     BooleanExpressionWidget
   },
   props: {
     provider: String,
   },

   data () {
     return {
       providerName: '',
       billingCondition: null,
       capacity: {
         hourly: null,
         daily: null,
         weekly: null,
         monthly: null
       }
     };
   },
    async created () {
      const response = await API.providers.getProvider(this.provider);
      this.providerName = response.data.provider.name;
      this.billingCondition = response.data.billing_condition;
      this.capacity = response.data.capacity || this.capacity;
   },
   computed: {
   },
    methods: {
      updateBillingCondition(billingCondition) {
        this.billingCondition = billingCondition;
      },
     close() {
       this.$emit('close');
     },
     async save() {
       let req = {
         billing_condition: this.billingCondition,
         capacity: this.capacity
       }
       try {
         await API.providers.update(this.provider, req);
         this.$emit('close');
       } catch (err) {
         window.alert(err.body)
       }
     }
   }
 }
</script>


<style>
.multiple-choices > div.formulate-input-group {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// ProviderModal.vue?956d8d2a